import React, { Component } from 'react';
import { Button,
    FormGroup,
    Table,
    Row,
    Col,
    CustomInput,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
    
// import classNames from "classnames";


class UploadPage extends Component {
    constructor(props) {
      super(props);
      this.state = {
        openDeleteModal: false,
        listInterval: '',
        currentPage: 1,
        pageSize: 100
      };
      this.aboutConfigFile = this.aboutConfigFile.bind(this);
    }
  
    componentDidMount() {
        // Initial data load - this will show the loading modal
        this.props.listReports(this.state.currentPage, this.state.pageSize);
        this.props.getJsonWarning();
        
        // Set interval for background refreshes - these will NOT show the loading modal
        this.setState({ 
          listInterval: setInterval(() => { 
            this.props.silentListReports(this.state.currentPage, this.state.pageSize);
            this.props.silentGetJsonWarning();
          }, 5000) 
        });
      }
  
    componentWillUnmount() {
        clearTimeout(this.state.listInterval);
        this.setState({ listInterval: '' });
    }

    aboutConfigFile = (e) => {
        this.setState({
            tmpFile: e.target.files[0],
            fileName: e.target.files[0].name,
        });
    }

    uploadFile = () => {
        this.props.onUploadFile(this.state.tmpFile);
    }

    handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
    }

    openConfirmModal = (fileInfo) => {
        this.setState({ targetFile: fileInfo, openDeleteModal: true });
    }

    closeConfirmModal = () => {
        this.setState({ openDeleteModal: false });
    }

    confirmDelete = () => {
        this.props.onDeleteUploadedFile(this.state.targetFile._id);
        this.closeConfirmModal();
    }

    openReportModal = () => {
        this.props.onGetReportStatus();
        this.setState({ openGenReportModal: true });
    }

    confirmGenReport = () => {
        this.props.onGenerateReport();
        this.closeGenReportModal();
    }

    closeGenReportModal = () => {
        this.setState({ openGenReportModal: false });
    }

    // Pagination handlers
    handlePageChange = (page) => {
        if (page !== this.state.currentPage) {
            this.setState({ currentPage: page }, () => {
                // Load data for the new page
                this.props.listReports(this.state.currentPage, this.state.pageSize);
            });
        }
    }

    renderPagination = () => {
        const { currentPage } = this.state;
        const { total_pages = 1 } = this.props.pagination || {};
        const { total = 0 } = this.props.pagination || {};
        
        // If there's only one page, don't show pagination
        if (total_pages <= 1) return null;
        
        // Create page numbers to show (1, 2, 3, 4, 5, ...)
        const pageNumbers = [];
        const maxDisplayPages = 10; // Number of page numbers to display
        
        for (let i = 1; i <= Math.min(maxDisplayPages, total_pages); i++) {
            pageNumbers.push(i);
        }
        
        // Add ellipsis and last page if needed
        if (total_pages > maxDisplayPages) {
            pageNumbers.push('...');
            if (!pageNumbers.includes(total_pages)) {
                pageNumbers.push(total_pages);
            }
        }
        
        return (
            <div className="d-flex align-items-center mb-3">
                <div className="mr-auto">
                    <span style={{ color: '#ffffff', fontSize: '16px', fontWeight: '500' }}>Total: {total} items</span>
                </div>
                
                <div className="d-flex">
                    <Button 
                        size="sm" 
                        color={currentPage === 1 ? "secondary" : "primary"}
                        outline
                        disabled={currentPage === 1}
                        onClick={() => this.handlePageChange(currentPage - 1)}
                        style={{ marginRight: '5px' }}
                    >
                        «
                    </Button>
                    
                    {pageNumbers.map((page, index) => {
                        if (page === '...') {
                            return (
                                <Button 
                                    key={`ellipsis-${index}`}
                                    size="sm" 
                                    color="secondary"
                                    outline
                                    disabled
                                    style={{ marginRight: '5px' }}
                                >
                                    {page}
                                </Button>
                            );
                        }
                        
                        return (
                            <Button 
                                key={page}
                                size="sm" 
                                color={currentPage === page ? "primary" : "secondary"}
                                outline={currentPage !== page}
                                onClick={() => this.handlePageChange(page)}
                                style={{ 
                                    marginRight: '5px',
                                    backgroundColor: currentPage === page ? '#8E44AD' : 'transparent',
                                    borderColor: currentPage === page ? '#8E44AD' : '#6c757d'
                                }}
                            >
                                {page}
                            </Button>
                        );
                    })}
                    
                    <Button 
                        size="sm" 
                        color={currentPage === total_pages ? "secondary" : "primary"}
                        outline
                        disabled={currentPage === total_pages}
                        onClick={() => this.handlePageChange(currentPage + 1)}
                    >
                        »
                    </Button>
                </div>
            </div>
        );
    }

    renderReportModal = () => {
        let reportStatus = typeof this.props.general_report_status !== "undefined" ? this.props.general_report_status : null;
        return(
            <Modal style={{marginTop:100}} isOpen={this.state.openGenReportModal} contentClassName='bg-dark text-light'>
                <ModalHeader> <div style={{color:"white"}}>Generate Report</div></ModalHeader>
                <ModalBody>
                    <div>Current Status: <span style={{fontWeight:"bold"}}>{reportStatus === null ? "NULL" : reportStatus}</span></div>
                    {(reportStatus == null || reportStatus === "Complete") &&
                        <div>Start Generating? The reports with the status "Import To DB Done" will start to generate in one minute after you click the confirm button</div>
                    }
                </ModalBody>
                <ModalFooter style={{
                    display: "flex",
                    justifyContent: "right",
                    }}>
                    {reportStatus !== "Ready" && reportStatus !== "Pending" &&
                        <Button style={{marginRight:3}} size='sm' color="success" onClick={this.confirmGenReport.bind(this)}> confirm </Button>
                    }
                    <Button style={{}} size='sm' color="danger" onClick={this.closeGenReportModal.bind(this)}> close </Button>
                </ModalFooter>
            </Modal>
        );
    }

    render() {
        // const { total = 0 } = this.props.pagination || {};
        
        return <div className="content">
            <Modal style={{marginTop:100}} isOpen={this.state.openDeleteModal} contentClassName='bg-dark text-light'>
                <ModalHeader> <div style={{color:"white"}}>Delete Uploaded File</div></ModalHeader>
                <ModalBody>
                    <div>Are you sure you want to delete this uploaded file? This action will also remove the DB data and the weekly report.</div>
                    {   
                        (typeof this.state.targetFile !== "undefined") &&
                            <>
                                <div style={{fontWeight:"bold"}}>File name : {this.state.targetFile.fileName}</div>
                                <div style={{fontWeight:"bold"}}>Duration : {this.state.targetFile.duration}</div>
                            </>
                            
                    }
                </ModalBody>
                <ModalFooter style={{
                    display: "flex",
                    justifyContent: "right",
                    }}>
                    <Button style={{marginRight:3}} size='sm' color="success" onClick={this.confirmDelete.bind(this)}> confirm </Button>
                    <Button style={{}} size='sm' color="danger" onClick={this.closeConfirmModal.bind(this)}> cancel </Button>
                </ModalFooter>
            </Modal>
            {this.renderReportModal()}
            <Row>
                <Col>
                <FormGroup>
                    <CustomInput
                    type="file"
                    id="customFileBrowser"
                    name="uploadWeeklyReport"
                    label={'choose an weekly report file'}
                    onClick={(event) => { 
                        event.target.value = null; 
                        this.setState({tmp_rules: undefined});
                    }} 
                    onChange={this.aboutConfigFile.bind(this)}
                    />
                    <Button onClick={() => {this.uploadFile()}}>
                        UPLOAD
                    </Button>
                </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col xs="12">
                    <Card>
                    <CardHeader>
                        <CardTitle style={{float: 'left'}} tag="h4">
                            Uploaded File
                        </CardTitle>
                        
                        <Button color='info' style={{float: 'right', marginRight:10}} id="generateReport" onClick={() => {this.openReportModal()}}> Generate Report </Button>
                        <h4 style={{float: 'right', marginRight:15, marginTop:10, color:"red"}}>{this.props.json_warning}</h4>
                    </CardHeader>
                    <CardBody>
                        {/* Render pagination above the table */}
                        {this.renderPagination()}
                        
                        <Table className="tablesorter" responsive>
                        <thead className="text-primary">
                            <tr>
                            <th>File Name</th>
                            <th>Upload Date</th>
                            <th>Duration</th>
                            {/* <th>Type</th> */}
                            <th>Status</th>
                            <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(typeof this.props.file_info !== "undefined") &&
                                this.props.file_info.map((file_info, index) => (
                                <tr key={index}>
                                    <td>{file_info.fileName}</td>
                                    <td>{file_info.uploadedTime}</td>
                                    <td>{file_info.duration}</td>
                                    {/* <td>Union</td> */}
                                    <td>{file_info.status}</td>
                                    <td>
                                        <Button color='info' size='sm' disabled={file_info.status !== "Weekly Report Done"} onClick={() => {this.props.downloadReport(file_info)}}><i className='fa fa-download' /></Button>
                                        <Button color='danger' size='sm' id="deleteReport" style={{marginLeft:5}} onClick={this.openConfirmModal.bind(this, file_info)}><i className='fa fa-trash' /></Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        </Table>
                    </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>;
    }
}

export default UploadPage;